<template>
    <div class="new-item-container">
        <v-dialog
                v-model="dialog"
                width="500">
            <template v-slot:activator="{ on }">
                <ClientsListNewItemButton
                        v-ripple
                        v-on:dialogOpened="openDialog()">
                </ClientsListNewItemButton>
            </template>
            <ClientsListNewItemForm
                    v-on:dialogClosed="closeDialog()">
            </ClientsListNewItemForm>
        </v-dialog>
    </div>
</template>

<script>
    import ClientsListNewItemButton from "./ClientsListNewItemButton";
    import ClientsListNewItemForm from "./ClientsListNewItemForm";

    export default {
        name: "ClientsListNewItem",
        components: {ClientsListNewItemForm, ClientsListNewItemButton},
        data: () => ({
            dialog: null
        }),
        methods: {
            openDialog: function () {
                this.dialog = true;
            },
            closeDialog: function () {
                this.dialog = false;
                this.$emit('clientAdded')
            }
        }
    }
</script>

<style scoped>

</style>
